import {
  Shield, Cloud, Phone, HardDrive, Globe, LifeBuoy, Receipt, KeyRound, FileText, Server,
  Wifi, Monitor, Mail, Lock, Package, Printer, Database, Camera,
} from "lucide-react";

export const ICONS = {
  Shield, Cloud, Phone, HardDrive, Globe, LifeBuoy, Receipt, KeyRound, FileText, Server,
  Wifi, Monitor, Mail, Lock, Package, Printer, Database, Camera,
};

export const PageIcon = ({ name, ...props }) => {
  const C = ICONS[name] || FileText;
  return <C {...props} />;
};
